export default function Schedule() {
  return (
    <section id="schedule" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="mb-4">
            <span className="text-[#FF6B35] text-sm font-bold uppercase tracking-wider">
              Class Schedule
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-[#0A1628] mb-6">
            Find Your Perfect Time
          </h2>
          <p className="text-gray-600 text-xl max-w-3xl mx-auto">
            Book directly through our scheduling system powered by Vagaro
          </p>
        </div>

        {/* Vagaro Integration Container */}
        <div className="max-w-5xl mx-auto">
          <div className="border-2 border-dashed border-gray-300 rounded-2xl p-16 text-center min-h-[500px] flex flex-col items-center justify-center bg-gray-50">
            <div className="mb-8">
              <i className="ri-calendar-schedule-line text-6xl text-[#FF6B35]"></i>
            </div>
            
            <h3 className="text-2xl font-bold text-[#0A1628] mb-4">
              Vagaro Schedule Widget Integration Zone
            </h3>
            
            <p className="text-gray-600 mb-8 max-w-2xl">
              This area is designed to support an embedded Vagaro scheduling widget or direct link to your Vagaro booking page. Connect your Vagaro account to enable real-time class scheduling and booking.
            </p>

            {/* CTA Button */}
            <button className="bg-[#FF6B35] text-white px-12 py-5 rounded-full font-bold text-lg hover:bg-[#ff5722] transition-all duration-300 hover:scale-105 flex items-center whitespace-nowrap cursor-pointer shadow-lg">
              View Full Schedule &amp; Book Classes
              <i className="ri-arrow-right-line ml-3 text-xl"></i>
            </button>

            {/* Technical Note */}
            <div className="mt-12 text-sm text-gray-500 max-w-xl">
              <p className="italic">
                Note: This section supports embedded Vagaro scheduling widgets or can link directly to your Vagaro booking page. Configure your Vagaro integration to display live class schedules, availability, and booking options.
              </p>
            </div>
          </div>

          {/* Powered by Vagaro */}
          <div className="text-center mt-8">
            <p className="text-gray-500 text-sm">
              Powered by Vagaro Scheduling System
            </p>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-16 grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="w-16 h-16 bg-[#FF6B35] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-white text-2xl"></i>
            </div>
            <h4 className="font-bold text-[#0A1628] mb-2">Flexible Times</h4>
            <p className="text-gray-600 text-sm">
              Classes throughout the day to fit your schedule
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-[#FF6B35] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-smartphone-line text-white text-2xl"></i>
            </div>
            <h4 className="font-bold text-[#0A1628] mb-2">Easy Booking</h4>
            <p className="text-gray-600 text-sm">
              Book and manage your classes from any device
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-[#FF6B35] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-notification-line text-white text-2xl"></i>
            </div>
            <h4 className="font-bold text-[#0A1628] mb-2">Reminders</h4>
            <p className="text-gray-600 text-sm">
              Get automatic reminders for your upcoming classes
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}